import { useState } from 'react';

import axios, { AxiosInstance, CancelTokenSource } from 'axios';

type FileUploadState = {
  error: string;
  isFileUploaded: boolean;
  loading: boolean;
  statusCode: number;
};
type FileUploadHookState = FileUploadState & {
  sendRequest: (params: SendFileUploadRequestParams) => Promise<void>;
};

const defaultState: FileUploadState = {
  error: null,
  isFileUploaded: false,
  loading: false,
  statusCode: null,
};

const axiosInstance: AxiosInstance = axios.create();

const useS3FileUpload = (): FileUploadHookState => {
  const [fileUploadState, setFileUploadState] =
    useState<FileUploadState>(defaultState);
  const [cancelTokenSource] = useState<CancelTokenSource>(
    axios.CancelToken.source(),
  );

  const sendRequest = async ({
    url,
    file,
  }: SendFileUploadRequestParams): Promise<any> => {
    setFileUploadState({
      ...defaultState,
      loading: true,
    });

    const newState: FileUploadState = {
      ...defaultState,
    };

    const options = {
      headers: {
        'Content-Type': file.type,
      },
      cancelToken: cancelTokenSource?.token,
    };

    try {
      const { status } = await axiosInstance.put(url, file, options);

      newState.statusCode = status;
      newState.isFileUploaded = status === 200;
    } catch (err) {
      newState.statusCode = 500;
    }
    newState.error =
      newState.statusCode === 200 ? null : 'Unable to upload file.';

    setFileUploadState(newState);
  };

  return {
    ...fileUploadState,
    sendRequest,
  };
};

export default useS3FileUpload;
